<template>
	<div class="page-content-wrapper">
		<div class="container-fluid">
			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-body" style="margin-bottom: 30px;">
							<h5>
								<i class="fas fa-users"></i> Selecciona el curso
							</h5>
							<div class="mt-4">
								<v-select
								    v-if="searchCurso != undefined && !globalLoadingMulticampus"
									placeholder="Listado cursos..."
									:options="searchCurso"
									label="tituloCurso"
									v-model="selected"
									@input="seleccionCurso(searchCurso)"
								>
									<template slot="option" slot-scope="option">
										{{ option.tituloCurso }}
									</template>
								</v-select>
								<PuSkeleton v-else :count="3"></PuSkeleton> 
								<small
									>Selecciona el curso, para poder visualizar
									los detalles de las evaluaciones.</small
								>
							</div>
						</div>
					</div>
				</div>
				<!-- end col -->
			</div>
		</div>

		<div v-if="loadPuskelton" class="container-fluid">
			<div class="row">
				<div class="col-xl-4">
					<div class="card">
						<div class="card-body">
							<PuSkeleton :count="5"> </PuSkeleton>
						</div>
					</div>
				</div>
				<div class="col-xl-8">
					<div class="card">
						<div class="card-body">
							<PuSkeleton :count="5"> </PuSkeleton>
						</div>
					</div>
				</div>
			</div>
		</div>
		<fechaComponent ref="fechaComponent" />
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import fechaComponent from "@/components/fechaConversionComponent";
export default {
	components: {
		fechaComponent,
	},
	data() {
		return {
			options: [],
			selected: "",
			loadPuskelton: false,
		};
	},
	computed:{
		...mapState('curso',['searchCurso']),
		...mapState("curso",["globalLoadingMulticampus"])
	},
	methods: {
		...mapActions("curso", ["updateOnlyCurso"]),
		...mapActions("alumno", ["updateJsonAlumno"]),
		...mapActions('alumno',['updateJsonCoordinadora']),
		...mapActions("evaluacion", ["updateControl"]),
		...mapActions("evaluacion", ["updateExamen"]),
		...mapActions("evaluacion", ["updateDiagnostico"]),
		...mapActions("evaluacion", ["updateRecuperativa"]),
		...mapActions("evaluacion", ["updateEvaluacion"]),
		...mapActions("modulo", ["updateModulo"]),
		...mapActions("profesor", ["updateProfesor"]),
		seleccionCurso() {
			this.loadPuskelton = true;
			this.items = [];
			this.idCurso = this.selected.idCurso;
			this.updateOnlyCurso([]);
			this.getInfoCurso(this.idCurso);
		},
		async getInfoCurso(idCurso) {
			const { data: dataCurso } = await this.axios.get(
				"api/getCurso/" + idCurso
			);
			const {
				getCurso,
				coordinadora,
				profesor,
				getModulos,
				alumnoLista,
				controlesCurso,
				examenCurso,
				diagnosticoCurso,
				recuperativaCurso,
			} = dataCurso;


			const controles = controlesCurso.map((control) => ({
				id: control.idEvaluacion,
				nombre: control.nombreEvaluacion,
				tipo: "control",
				exigencia: this.exigenciaValor(control.ponderacion),
				fecha_inicio: this.formatoFecha(control.fechaHabilitacion),
				fecha_cierre: this.formatoFecha(control.fechaCierre),
			}));

			const examenes = examenCurso.map((examen) => ({
				nombre: examen.nombreEvaluacion,
				tipo: "examen",
				id:examenCurso[0].idEvaluacion,
				exigencia: this.exigenciaValor(examen.ponderacion),
				fecha_inicio: this.formatoFecha(examen.fechaHabilitacion),
				fecha_termino: this.formatoFecha(examen.fechaCierre),
			}));

			const diagnosticos = diagnosticoCurso.map((diagnostico) => ({
				nombre: diagnostico.nombreEvaluacion,
				tipo: "diagnostico",
				id:diagnostico.idEvaluacion,
				exigencia: this.exigenciaValor(diagnostico.ponderacion),
				fecha_inicio: this.formatoFecha(diagnostico.fechaHabilitacion),
				fecha_termino: this.formatoFecha(diagnostico.fechaCierre),
			}));

			const recuperativas = recuperativaCurso.map((recuperativa) => ({
				nombre: recuperativa.nombreEvaluacion,
				tipo: "recuperativa",
				exigencia: this.exigenciaValor(recuperativa.ponderacion),
				fecha_inicio: this.formatoFecha(recuperativa.fechaHabilitacion),
				fecha_termino: this.formatoFecha(recuperativa.fechaCierre),
			}));

			const evaluacionesCurso = [].concat(
				controles,
				examenes,
				diagnosticos,
				recuperativas
			);

			//carga vuex
			this.updateEvaluacion(evaluacionesCurso);
			this.updateModulo(getModulos);
			this.updateOnlyCurso(getCurso);
			this.updateJsonCoordinadora(
				coordinadora ? coordinadora : { nombre: "No Asignado" }
			)
/* 			this.updateCoordinadora(
				coordinadora ? coordinadora : { nombre: "No Asignado" }
			); */

			this.updateProfesor(
				profesor ? profesor : { nombre: "No Asignado" }
			);
			this.updateJsonAlumno(alumnoLista);
			this.updateControl(controlesCurso);
			this.updateExamen(examenCurso);
			this.updateDiagnostico(diagnosticoCurso);
			this.updateRecuperativa(recuperativaCurso);

			this.loadEvaluacion = true;
			this.loadPuskelton = false;
			this.loadAlumnos = false;
			this.loadTablaAlumno = false;
		},

		formatoFecha(fecha) {
			return (fecha) ? this.$refs.fechaComponent.fechaFinal(fecha) : '-';
		},
		exigenciaValor(valor) {
			return (valor) ? valor * 100 + "%" : "-"
		},
	},
	created() {
		this.updateOnlyCurso([]);
	},
};
</script>
